export default "__VITE_ASSET__DMr76$Ez__"